/**
 * Utilitários para conversão e formatação de moeda
 */

/**
 * Mapeamento de idioma para código de moeda
 */
export const LANGUAGE_TO_CURRENCY: Record<string, string> = {
  'pt-BR': 'BRL', // Real Brasileiro
  'pt-PT': 'EUR', // Euro
  'en-US': 'USD', // Dólar Americano
  'es-ES': 'EUR', // Euro
};

/**
 * Mapeamento de idioma para locale (para formatação)
 */
export const LANGUAGE_TO_LOCALE: Record<string, string> = {
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
};

/**
 * Taxas de câmbio fixas como fallback (USD como base)
 */
export const FALLBACK_EXCHANGE_RATES: Record<string, number> = {
  USD: 1.0,
  BRL: 5.0,
  EUR: 0.92,
};

/**
 * Retorna o código da moeda baseado no idioma
 * @param language Código do idioma (ex: 'pt-BR', 'en-US')
 * @returns Código da moeda (ex: 'BRL', 'USD', 'EUR')
 */
export function getCurrencyByLanguage(language: string): string {
  return LANGUAGE_TO_CURRENCY[language] || 'USD';
}

/**
 * Retorna o locale baseado no idioma
 * @param language Código do idioma (ex: 'pt-BR', 'en-US')
 * @returns Locale (ex: 'pt-BR', 'en-US')
 */
export function getLocaleByLanguage(language: string): string {
  return LANGUAGE_TO_LOCALE[language] || 'en-US';
}

/**
 * Formata um valor monetário na moeda e locale especificados
 * @param amount Valor a ser formatado
 * @param currency Código da moeda (ex: 'BRL', 'USD', 'EUR')
 * @param locale Locale para formatação (ex: 'pt-BR', 'en-US')
 * @returns String formatada (ex: 'R$ 100,00', '$100.00', '€100,00')
 */
export function formatCurrency(
  amount: number,
  currency: string,
  locale: string
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Converte um valor de USD para outra moeda
 * @param amountUSD Valor em USD
 * @param targetCurrency Moeda de destino (ex: 'BRL', 'EUR')
 * @param exchangeRate Taxa de câmbio (quantos da moeda de destino equivalem a 1 USD)
 * @returns Valor convertido
 */
export function convertUSDToCurrency(
  amountUSD: number,
  targetCurrency: string,
  exchangeRate: number
): number {
  if (targetCurrency === 'USD') {
    return amountUSD;
  }
  return amountUSD * exchangeRate;
}
